import { Injectable } from '@angular/core';
import { Response, RequestOptionsArgs, Headers, Http, Connection, RequestOptions } from '@angular/http';

import { API_ENDPOINTS } from '../../shared/configuration/api-endpoints';
import { CONFIGURATION } from '../../shared/configuration/configuration';

import { StorageService } from '../../shared/services/storage.service';
import { ErrorService } from '../../shared/services/error.service';
import { PopupService } from '../../shared/services/pop-up.service';
import { PageNavigationService } from '../../shared/services/page-navigation.service';
import { FileService } from '../../shared/services/file.service';
declare var require: any
import { STATIC_VALUE } from 'app/shared/configuration/static.value';
import * as moment from 'moment';


@Injectable()
export class PlantMapService {
    let
    RB_Purpose: string;

    vPlantMapData = {
        plant_record_id: '',
        plant_request_id: '',
        onepay_reference_id: '',
        merchant: '',
        result: '',
        session_id: '',
        session_update_status: '',
        session_version: '',
        success_indicator: '',
        orderId: '',
        orderRef: '',
        transRef: ''
    }

    vEarthworkDetailsData = {
        project_title: '',
        location: '',
        main_contractor: '',
        purchaser_company_name: '',
        Purpose_Radiobutton: '',
        purpose_of_planmap_Others: ''
    };

    vAreaOfInterestData = {
        a2_amount: 0,
        restricted_area: -1,
        amount_payable: 0,
        coordinate11: 0,
        coordinate12: 0,
        coordinate21: 0,
        coordinate22: 0,
        coordinate31: 0,
        coordinate32: 0,
        coordinate41: 0,
        coordinate42: 0,
        flow: ''

    };

    vSearchResults: Array<{
        searchVal: string,
        latitude: number,
        longitude: number,
    }> = [];

    vPaymentData = {
        quantity: 0,
        unitPrice: 0,
        totalPrice: 0,
        paymentMethod: ''
    }

    vTransactionHistory = {
        status: 0
    }

    vLoadingStatus: boolean;
    vRestrictedArea_skip_payment: boolean;

    vIsPaymentPending: boolean = false;
    vPlantLists: any;
    password: any;

    constructor(
        private _http: Http,
        private _errorService: ErrorService,
        private _fileService: FileService,
        private _storageService: StorageService,
        private _popupService: PopupService,
        private _pageNavigationService: PageNavigationService,
    ) {
        this.vLoadingStatus = false;
        this.vRestrictedArea_skip_payment = false;
        this.resetEarthworkDetails();
        this.resetAreaOfInterest();
        this.resetPlantMapData();
        this.resetUploadDocumentData();
        this.resetPaymentData();
    }

    // just for mocking up notification API.Can be removed once the notification API is invoked by SVZ.
    uploadToFileDMS() {
        let bodyforInvokingNotification = {
            "fileName": 'charge_01.pdf',
            "prpRefNo": '999-17-13062024-00069-A'

        }
        this._http.post(API_ENDPOINTS.PLANT_MAP.NOTIFICATION618, bodyforInvokingNotification).subscribe((response) => {
            console.log(response, 'aakriti')

            let bdy = {
                "fileName": response['data'].fileName,
                "userGroup": "PRP System Service Account"
            }
            const credentials = btoa('dmsapi:dmpapi123');
            let header: Headers = new Headers({
                'Content-Type': 'application/json',
                'Authorization': 'Basic ZG1zYXBpOmRtc2FwaTEyMw==',

            });
            // this.downloadDMS(bdy, header);
        }

        )
    }

    // downloadDMS(bdy, header) {
    //     this._http.post('http://10.6.4.59:5002/dms/file/download', bdy, { headers: header}).subscribe((response: any) => {
    //         console.log(response, ' fileNames');
    //         // zipping using JSZip file.
    //         // var zip = new JSZip();
    //         // zip.file("Hello.txt", response);
    //         // zip.generateAsync({ type: 'blob' }).then(function(content) {
    //         //     // see FileSaver.js
    //         //     console.log(content,'content')
    //         //     saveAs(content, 'example.zip');
    //         //   });
    //        // let fileType = this.getFileType(bdy.fileName);

    //         let blob: any = new Blob([response], { type: 'text/plain; charset=utf-8' });
    //         var file = new File([blob], 'mySampleFile.txt', {type: 'text/plain; charset=utf-8', lastModified: Date.now()});
    //         console.log(file,'fileValue');                        

    //        saveAs(file);


    //        let header1: Headers = new Headers({
    //         'Authorization': 'Basic ZG1zYXBpOmRtc2FwaTEyMw==',


    //     });

    //         let metaDataInfo = {
    //             "incidentid": "I123",
    //             "worklogid": "W123"
    //         };
    //         const formData = new FormData(); 
    //         formData.append('fileAttachment', file.name);            
    //         //formData.append('fileType', 'zip');
    //         formData.append('fileName', 'aakriti-1/2/2024.txt');
    //         formData.append('appName', 'swp');
    //         formData.append('userGroup', 'PRP System Service Account');
    //         formData.append('metaDataInfo', JSON.stringify(metaDataInfo));
    //         formData.append('file', file.name);
    //         formData.append('category', 'common');
    //         console.log(formData.get('appName'), 'formData');
    //         var options = { content: formData };

    //         this._http.post('http://10.6.4.59:5002/dms/file/upload',formData,{ headers: header1}).subscribe((response) => {
    //             console.log(response,'response upload dms');

    //             //Once the upload is successful, then need to trigger email services that the zip file can
    //             //be downloaded from the myORDERS page.

    //         },

    //         (error) => {
    //             console.log(error);
    //             let vErrorData = error;
    //             this._errorService.setErrorFlag(true);
    //             this._errorService.setBackEndError(vErrorData.code, vErrorData.desc);
    //         })

    //     })
    // }
    // this can be uncommented once the download/upload is fixed
    // getFileType(fileName: string): string {
    //     // Extract file extension from the file name
    //     const fileExtension = fileName.split('.').pop().toLowerCase() || '';

    //     // Map file extensions to corresponding file types
    //     const fileTypeMap: { [key: string]: string } = {
    //       pdf: 'application/pdf',
    //       csv: 'text/csv',
    //       txt: 'text/plain',
    //       doc: 'application/msword',
    //       // Add more mappings as needed
    //     };

    //     // Retrieve file type based on the file extension
    //     const fileType = fileTypeMap[fileExtension] || 'application/msword';

    //     return fileType;
    //   }

    getEarthworkDetailsData() {
        return this.vEarthworkDetailsData;
    }

    getAreaOfInterestData() {
        return this.vAreaOfInterestData;
    }

    getPaymentData() {
        return this.vPaymentData;
    }

    getSearchResults() {
        return this.vSearchResults;
    }

    getRequestId() {
        return this.vPlantMapData.plant_request_id;
    }

    getRecordId() {
        return this.vPlantMapData.plant_record_id;
    }

    setAreaOfInterestData(data: any) {
        this.vAreaOfInterestData = data;
    }

    isLoading() {
        return this.vLoadingStatus;
    }
    isRestrictedArea_skip_payment() {
        return this.vRestrictedArea_skip_payment;
    }

    getIsPaymentPending() {
        return this.vIsPaymentPending;
    }

    setIsPaymentPending(pIsPaymentPending: boolean) {
        this.vIsPaymentPending = pIsPaymentPending;
    }

    resetPlantMapData() {
        let data = this._storageService.getSessionItem('plantMapData');
        if (data !== null) {
            this.vPlantMapData = JSON.parse(data);
        } else {
            this.vPlantMapData = {
                plant_record_id: '',
                plant_request_id: '',
                onepay_reference_id: '',
                merchant: '',
                result: '',
                session_id: '',
                session_update_status: '',
                session_version: '',
                success_indicator: '',
                orderId: '',
                orderRef: '',
                transRef: ''
            };
        }
    }

    resetEarthworkDetails() {
        let data = this._storageService.getSessionItem('plantMapEarthWork');
        if (data !== null) {
            this.vEarthworkDetailsData = JSON.parse(data);
        } else {
            this.vEarthworkDetailsData = {
                project_title: '',
                location: '',
                main_contractor: '',
                purchaser_company_name: '',
                Purpose_Radiobutton: '',
                purpose_of_planmap_Others: ''
            };
        }
    }

    resetAreaOfInterest() {
        let data = this._storageService.getSessionItem('plantMapAreaInterest');
        let flow = this._storageService.getSessionItem('flowtype');

        if (data !== null) {
            this.vAreaOfInterestData = JSON.parse(data);
        } else {
            this.vAreaOfInterestData = {
                a2_amount: 0,
                restricted_area: -1,
                amount_payable: 0,
                coordinate11: 0,
                coordinate12: 0,
                coordinate21: 0,
                coordinate22: 0,
                coordinate31: 0,
                coordinate32: 0,
                coordinate41: 0,
                coordinate42: 0,
                flow: flow
            };
        }
    }

    resetUploadDocumentData() {
        var tempFiles = this._storageService.getSessionItem('plantmapFiles');
        var vFiles;
        if (tempFiles === null || tempFiles === undefined) {
            vFiles = [];
        } else {
            try {
                vFiles = JSON.parse(tempFiles);
            } catch (e) {
                vFiles = [];
            }
        }
        this._fileService.vFiles = vFiles;
    }

    resetPaymentData() {
        let data = this._storageService.getSessionItem('plantMapPayment');
        if (data !== null) {
            let parsedData = JSON.parse(data);
            this.vPaymentData.paymentMethod = "CREDIT_CARD"; //Kowsalya
            this.vPaymentData.quantity = parsedData.quantity;
            this.vPaymentData.totalPrice = parsedData.totalPrice;
            this.vPaymentData.unitPrice = parsedData.unitPrice;
        } else {
            this.vPaymentData = {
                paymentMethod: "",
                quantity: 0,
                totalPrice: 0,
                unitPrice: 0
            };
        }
    }

    resetAllData() {
        this._storageService.removeSessionItem('plantMapData');
        this._storageService.removeSessionItem('plantMapEarthWork');
        this._storageService.removeSessionItem('plantMapAreaInterest');
        this._storageService.removeSessionItem('plantmapFiles');
        this._storageService.removeSessionItem('plantMapPayment');
        this.resetEarthworkDetails();
        this.resetAreaOfInterest();
        this.resetPlantMapData();
        this.resetUploadDocumentData();
        this.resetPaymentData();
    }

    resetError() {
        this._errorService.resetErrorFlag();
        this._errorService.resetError();
        this._errorService.resetBackEndError();
    }

    isDisableEarthworkDetailsData() {
        if (this.vEarthworkDetailsData.project_title.trim() === undefined || this.vEarthworkDetailsData.project_title.trim() === '') {
            return true;
        } else if (this.vEarthworkDetailsData.location.trim() === undefined || this.vEarthworkDetailsData.location.trim() === '') {
            return true;
        } else if (this.vEarthworkDetailsData.main_contractor.trim() === undefined || this.vEarthworkDetailsData.main_contractor.trim() === '') {
            return true;
        } else if (this.vEarthworkDetailsData.purchaser_company_name.trim() === undefined || this.vEarthworkDetailsData.purchaser_company_name.trim() === '') {
            return true;
        } else if (this.vEarthworkDetailsData.Purpose_Radiobutton === undefined || this.vEarthworkDetailsData.Purpose_Radiobutton === '') {
            return true;
        }  //Kowsalya
        return false;
    }

    //Kowsalya
    isDisablePurpose() {
        if (this.vEarthworkDetailsData.purpose_of_planmap_Others === undefined || this.vEarthworkDetailsData.purpose_of_planmap_Others === '') {
            return true;
        }
        return false;
    }
    //Kowsalya

    isDisableAreaOfInterest() {
        return (this.vAreaOfInterestData.coordinate11 === undefined || this.vAreaOfInterestData.a2_amount === 0 || this.vAreaOfInterestData.restricted_area === -1) ? true : false;
    }

    isDisableSaveUpload() {
        return this._fileService.getFileLists().length < 1;
    }

    isDisablePayment() {
        return (this.vPaymentData.paymentMethod === undefined || this.vPaymentData.paymentMethod === '') ? true : false;
    }

    needPayment() {
        if (this.vPaymentData.totalPrice === 0) {
            return false;
        }
        return true;
    }

    saveEarthworkDetails() {
        this._storageService.setSessionItem('plantMapEarthWork', JSON.stringify(this.vEarthworkDetailsData));
        let vLink = ['plant-map/area-of-interest'];
        this._pageNavigationService.navigate(vLink);
    }

    saveAreaOfInterest() {
        this.vLoadingStatus = true;
        let xData = {
            a2_amount: this.vAreaOfInterestData.a2_amount,
        };

        this._http.post(API_ENDPOINTS.PLANT_MAP.CHECK_DAILY_LIMIT, xData).subscribe(
            (response) => {
                this.vLoadingStatus = false;

                this._storageService.setSessionItem('plantMapAreaInterest', JSON.stringify(this.vAreaOfInterestData));
                if (this.vAreaOfInterestData.restricted_area == 0) {
                    this._pageNavigationService.navigate(['plant-map/payment']);
                } else {
                    this.saveTemporaryPlantmap();
                }
                this.vSearchResults = [];
            },
            (error) => {
                this.vLoadingStatus = false;
                console.log(error);
                let vErrorData = error;
                this._errorService.setErrorFlag(true);
                this._errorService.setBackEndError(vErrorData.code, vErrorData.desc);
            }
        );

    }

    saveTemporaryPlantmap() {

        let xData = {
            project_title: this.vEarthworkDetailsData.project_title,
            location: this.vEarthworkDetailsData.location,
            main_contractor: this.vEarthworkDetailsData.main_contractor,
            purchaser_company_name: this.vEarthworkDetailsData.purchaser_company_name,
            Purpose_Radiobutton: this.vEarthworkDetailsData.Purpose_Radiobutton,//Kowsalya
            purpose_of_planmap_Others: this.vEarthworkDetailsData.purpose_of_planmap_Others,//Kowsalya
            a2_amount: this.vAreaOfInterestData.a2_amount,
            plant_record_id: !Number(this.vPlantMapData.plant_record_id) ? 0 : parseInt(this.vPlantMapData.plant_record_id),
            coordinate: [
                [this.vAreaOfInterestData.coordinate11, this.vAreaOfInterestData.coordinate12],
                [this.vAreaOfInterestData.coordinate21, this.vAreaOfInterestData.coordinate22],
                [this.vAreaOfInterestData.coordinate31, this.vAreaOfInterestData.coordinate32],
                [this.vAreaOfInterestData.coordinate41, this.vAreaOfInterestData.coordinate42]
            ]
        };

        this.vLoadingStatus = true;

        this._http.post(API_ENDPOINTS.PLANT_MAP.CREATE_TEMPORARY_PLANTMAP, xData).subscribe(
            (response) => {
                this.vLoadingStatus = false;
                let vResponseData: any = response;
                console.log(vResponseData);

                this.vPlantMapData.plant_record_id = vResponseData.data.plant_record_id.toString();
                this.vPlantMapData.plant_request_id = vResponseData.data.plant_request_id.toString(); // GANESH
                this._storageService.setSessionItem('plantMapData', JSON.stringify(this.vPlantMapData));

                let vLink = ['plant-map/upload-document'];
                this._pageNavigationService.navigate(vLink);
            },
            (error) => {
                this.vLoadingStatus = false;
                console.log(error);
                let vErrorData = error;
                this._errorService.setErrorFlag(true);
                this._errorService.setBackEndError(vErrorData.code, vErrorData.desc);
            }
        );
    }

    submitPayment() {
        let restrictedArea = this.vAreaOfInterestData.restricted_area;
        //alert(restrictedArea);
        if (restrictedArea === 1) {
            this.vRestrictedArea_skip_payment = false;
            this.submitPaymentRestricted();
        } else if (restrictedArea === 0) {
            this.vRestrictedArea_skip_payment = false;
            this.submitPaymentNoRestricted();
        }
    }

    submitPayment_res(data: any) {
        let restrictedArea = this.vAreaOfInterestData.restricted_area;
        //this.vRestrictedArea_skip_payment = data;
        if (restrictedArea === 1) {
            this.vRestrictedArea_skip_payment = true;
            this.submitPaymentRestricted();
        } else if (restrictedArea === 0) {
            this.vRestrictedArea_skip_payment = false;
            this.submitPaymentNoRestricted();
        }
    }

    submitPaymentRestricted() {
        this.vLoadingStatus = true;
        if (this.vRestrictedArea_skip_payment) {
            this.vPaymentData.paymentMethod = "CREDIT_CARD";
        }
        let xData = {
            plant_record_id: !Number(this.vPlantMapData.plant_record_id) ? 0 : parseInt(this.vPlantMapData.plant_record_id),
            trans_method: this.vPaymentData.paymentMethod,
            trans_amount: this.vPaymentData.totalPrice,
            restrictedArea_skip_payment: this.vRestrictedArea_skip_payment // This is to skip the payment form initail transaction for restricted area.
        };
        /*alert("plant_record_id--"+this.vPlantMapData.plant_record_id);
        alert("trans_method--"+this.vPaymentData.paymentMethod);
        alert("trans_amount--"+this.vPaymentData.totalPrice);
        alert("restrictedArea_skip_payment--"+this.vRestrictedArea_skip_payment);
        */
        this._http.post(API_ENDPOINTS.PLANT_MAP.UPDATE_TEMPORARY_PLANTMAP, xData).subscribe(
            (response) => {
                let vResponseData: any = response;
                // alert(vResponseData.data.restrictedArea_skip_payment);
                if (vResponseData.data.restrictedArea_skip_payment) {
                    this.vLoadingStatus = false;
                    this.vPlantMapData.plant_record_id = vResponseData.data.plant_record_id;
                    this.vPlantMapData.plant_request_id = vResponseData.data.plant_request_id;
                    //alert(this.vPlantMapData.plant_record_id);
                    //alert(this.vPlantMapData.plant_request_id);
                    let vLink = ['plant-map/confirmation'];
                    this._pageNavigationService.navigate(vLink);
                }

                this.vPlantMapData.merchant = vResponseData.data.merchant;
                this.vPlantMapData.result = vResponseData.data.result;
                this.vPlantMapData.session_id = vResponseData.data.session_id;
                this.vPlantMapData.session_update_status = vResponseData.data.session_updateStatus;
                this.vPlantMapData.session_version = vResponseData.data.session_version;
                this.vPlantMapData.success_indicator = vResponseData.data.successIndicator;
                this.vPlantMapData.orderId = vResponseData.data.order_id;
                this.vPlantMapData.orderRef = vResponseData.data.order_ref;
                this.vPlantMapData.transRef = vResponseData.data.trans_ref;

                this.vPlantMapData.plant_record_id = vResponseData.data.plant_record_id;
                this.vPlantMapData.plant_request_id = vResponseData.data.plant_request_id;
                this.vPlantMapData.onepay_reference_id = vResponseData.data.onepay_reference_id;
                this._storageService.setSessionItem('plantMapData', JSON.stringify(this.vPlantMapData));
                console.log(vResponseData);
                if (vResponseData.data.session_id === undefined) {
                    this.vLoadingStatus = false;
                    let vLink = ['plant-map/confirmation'];
                    this._pageNavigationService.navigate(vLink);
                } else {
                    if (vResponseData.data.session_id != null) {
                        this.checkoutConfirguration(this.vPaymentData.totalPrice, vResponseData.data.order_id, vResponseData.data.session_id, vResponseData.data.trans_ref, vResponseData.data.order_ref);
                        Checkout.showPaymentPage();
                        ///this.vLoadingStatus = false;
                    } else {
                        this.vLoadingStatus = false;
                        this._popupService.openGeneralConfirmationPopup('Error', 'Failed to process payment, please try again.', '', false, false);
                    }
                }
            },
            (error) => {
                this.vLoadingStatus = false;
                console.log(error);
                if (error.plant_record_id !== undefined && error.plant_request_id !== undefined) {
                    this.vPlantMapData.plant_record_id = error.plant_record_id;
                    this.vPlantMapData.plant_request_id = error.plant_request_id;
                    this._storageService.setSessionItem('plantMapData', JSON.stringify(this.vPlantMapData));
                }
                if (error.code === 53505) {
                    let vErrorData = error;
                    this._errorService.setErrorFlag(true);
                    this._errorService.setBackEndError(vErrorData.code, vErrorData.desc);
                } else
                    this._popupService.openGeneralConfirmationPopup('Notice', 'Your payment is unsuccessful, please try again later.', '', false, false);
                this.vLoadingStatus = false;
            }
        );
    }

    submitPaymentNoRestricted() {
        //alert('submitPaymentNoRestricted'+this.vRestrictedArea_skip_payment);
        let xData = {
            project_title: this.vEarthworkDetailsData.project_title,
            location: this.vEarthworkDetailsData.location,
            main_contractor: this.vEarthworkDetailsData.main_contractor,
            purchaser_company_name: this.vEarthworkDetailsData.purchaser_company_name,
            Purpose_Radiobutton: this.vEarthworkDetailsData.Purpose_Radiobutton,//Kowsalya
            purpose_of_planmap_Others: this.vEarthworkDetailsData.purpose_of_planmap_Others,//Kowsalya
            a2_amount: this.vAreaOfInterestData.a2_amount,
            plant_record_id: !Number(this.vPlantMapData.plant_record_id) ? 0 : parseInt(this.vPlantMapData.plant_record_id),
            coordinate: [
                [this.vAreaOfInterestData.coordinate11, this.vAreaOfInterestData.coordinate12],
                [this.vAreaOfInterestData.coordinate21, this.vAreaOfInterestData.coordinate22],
                [this.vAreaOfInterestData.coordinate31, this.vAreaOfInterestData.coordinate32],
                [this.vAreaOfInterestData.coordinate41, this.vAreaOfInterestData.coordinate42]
            ],
            trans_method: this.vPaymentData.paymentMethod,
            trans_amount: this.vPaymentData.totalPrice,
            restrictedArea_skip_payment: this.vRestrictedArea_skip_payment

        };

        this.vLoadingStatus = true;
        this._http.post(API_ENDPOINTS.PLANT_MAP.CREATE_PLANTMAP_NO_RESTRICTED, xData).subscribe(
            (response) => {
                let vResponseData: any = response;
                this.vPlantMapData.merchant = vResponseData.data.merchant;
                this.vPlantMapData.result = vResponseData.data.result;
                this.vPlantMapData.session_id = vResponseData.data.session_id;
                this.vPlantMapData.session_update_status = vResponseData.data.session_updateStatus;
                this.vPlantMapData.session_version = vResponseData.data.session_version;
                this.vPlantMapData.success_indicator = vResponseData.data.successIndicator;
                this.vPlantMapData.orderId = vResponseData.data.order_id;
                this.vPlantMapData.orderRef = vResponseData.data.order_ref;
                this.vPlantMapData.transRef = vResponseData.data.trans_ref;

                this.vPlantMapData.plant_record_id = vResponseData.data.plant_record_id;
                this.vPlantMapData.plant_request_id = vResponseData.data.plant_request_id;
                //this.vPlantMapData.onepay_reference_id = vResponseData.data.onepay_reference_id;
                this._storageService.setSessionItem('plantMapData', JSON.stringify(this.vPlantMapData));
                console.log("Line 458", vResponseData);
                // alert('submitPaymentNoRestricted*****'+vResponseData.data.session_id);
                if (vResponseData.data.session_id === undefined) {
                    this.vLoadingStatus = false;
                    let vLink = ['plant-map/confirmation'];
                    this._pageNavigationService.navigate(vLink);
                } else {
                    if (vResponseData.data.session_id != null) {
                        this.checkoutConfirguration(this.vPaymentData.totalPrice, vResponseData.data.order_id, vResponseData.data.session_id, vResponseData.data.trans_ref, vResponseData.data.order_ref);
                        Checkout.showPaymentPage();
                        ///this.vLoadingStatus = false;
                    }
                    else {
                        this.vLoadingStatus = false;
                        this._popupService.openGeneralConfirmationPopup('Error', 'Failed to process payment, please try again.', '', false, false);
                    }
                }

                // if(vResponseData.data.URL === undefined){
                //     this.vLoadingStatus = false;
                //     let vLink = ['plant-map/confirmation'];
                //     this._pageNavigationService.navigate(vLink);
                // } else {
                //     var url = vResponseData.data.URL;
                //     if(url.indexOf(CONFIGURATION.payRedirectConfig[CONFIGURATION.modeEnv].URL) > -1){
                //         window.location.href = url;
                //     } else {
                //         this.vLoadingStatus = false;
                //         this._popupService.openGeneralConfirmationPopup('Error', 'Failed to process payment, please try again.', '', false, false);
                //     }
                // }
            },
            (error) => {
                this.vLoadingStatus = false;
                console.log(error);
                if (error.plant_record_id !== undefined && error.plant_request_id !== undefined) {
                    this.vPlantMapData.plant_record_id = error.plant_record_id;
                    this.vPlantMapData.plant_request_id = error.plant_request_id;
                    this._storageService.setSessionItem('plantMapData', JSON.stringify(this.vPlantMapData));
                }
                if (error.code === 53505) {
                    let vErrorData = error;
                    this._errorService.setErrorFlag(true);
                    this._errorService.setBackEndError(vErrorData.code, vErrorData.desc);
                } else {
                    //this._popupService.openGeneralConfirmationPopup('Notice', 'Your payment is unsuccessful, please try again later.', '', false, false);
                    //this.vLoadingStatus = false;
                    console.log('Bypassing');
                    // GANESH
                    let vLink = ['plant-map/confirmation'];
                    this._pageNavigationService.navigate(vLink);
                }

            }
        );
    }




    checkoutConfirguration(trans_amount: any, request_id: any, sessionValue: any, transref: any, orderref: any) {
        console.log('Payment Order ID: ' + request_id);
        //alert('Payment Order ID: '+request_id);

        Checkout.configure({
 		 // order: {
            //     amount: trans_amount,
            //     currency: 'SGD',
            //     description: 'Plant Map Purchase',
            //     id: request_id,
            //     reference: orderref
            // },
            // transaction: {
            //     reference: transref
            // },

            // interaction: {
            //     operation: 'PURCHASE',
            //     merchant: {
            //         name: 'NETLINK MANAGEMENT P L'
            //     }
            // },
            session: {
                id: sessionValue
            }
        });

        // alert('Checkout Configuration: '+JSON.stringify(configurationValue));        
    }




    gisPlantmapHit() {
        if (this.vAreaOfInterestData.restricted_area === 1 || this.vAreaOfInterestData.restricted_area === -1) {
            this.resetAllData();
            return;
        }
        let xData = {
            plant_record_id: this.vPlantMapData.plant_record_id
        };
        this._http.post(API_ENDPOINTS.PLANT_MAP.GIS_HIT, xData).subscribe();
    }

    getPaymentAvailability() {
        this.vLoadingStatus = true;
        var promise = this._http.get(API_ENDPOINTS.ACCOUNT.PAYMENT_CREDENTIAL);

        let p = new Promise((resolve, reject) => {
            promise.subscribe(
                (response) => {
                    this.vLoadingStatus = false;
                    let vResponseData = response;
                    console.log(vResponseData);
                    resolve(response);
                },
                (error) => {
                    console.log(error);
                    this.vLoadingStatus = false;
                    let vErrorData = error;
                    this._errorService.setErrorFlag(true);
                    this._errorService.setBackEndError(vErrorData.code, vErrorData.desc);
                    reject();
                });
        });
        return p;
    }

    loadTransaction(pFailureReason: string) {
        this.vLoadingStatus = true;
        let data = this._storageService.getSessionItem('plantMapData');
        this.vPlantMapData = JSON.parse(data);
        let xData = {
            plant_record_id: this.vPlantMapData.plant_record_id,
            onepay_reference_id: this.vPlantMapData.orderId,
            failure_reason: pFailureReason === undefined || pFailureReason === null ? '' : pFailureReason
        }
        var promise = this._http.post(API_ENDPOINTS.PLANT_MAP.LOAD_TRANSACTION, xData);
        let p = new Promise((resolve, reject) => {
            promise.subscribe(
                (response) => {
                    this.vLoadingStatus = false;
                    let vResponseData: any = response;
                    // once payment is successful call the api for printing maps svz
                    if (vResponseData['data'].status === STATIC_VALUE.ALL_PLANT_STATUS.PAYMENT_RECEIVED) {
                        this.callPrintpurchasePlanMap();
                    }
                    resolve(vResponseData);
                },
                (error) => {
                    console.log(error);
                    this.vLoadingStatus = false;
                    let vErrorData = error;
                    this._errorService.setErrorFlag(true);
                    this._errorService.setBackEndError(vErrorData.code, vErrorData.desc);
                    reject();
                });
        });
        return p;
    }

    //Kowsalya
    LoadPopup(projecttitle, maincontractor, loc, Rb_purpose, purpose) {

        console.log("Line 542", projecttitle, maincontractor, loc, Rb_purpose, purpose);
        let xData = {
            project_title: projecttitle,
            main_contractor: maincontractor,
            location: loc,
            Purpose_Radiobutton: Rb_purpose,
            purpose_of_planmap_Others: purpose
        }
        var promise = this._http.post(API_ENDPOINTS.PLANT_MAP.CHECK_TRANS_HIS_VAL, xData);
        let p = new Promise((resolve, reject) => {
            promise.subscribe(
                (response) => {
                    this.vLoadingStatus = false;
                    let vResponseData: any = response;
                    console.log(vResponseData);
                    resolve(vResponseData);

                },
                (error) => {
                    console.log(error);
                    this.vLoadingStatus = false;
                    let vErrorData = error;
                    console.log(vErrorData);
                    this._errorService.setErrorFlag(true);
                    this._errorService.setBackEndError(vErrorData.code, vErrorData.desc);
                    reject();
                });
        });
        return p;
    }//Kowsalya

    getPrevDraw() {
        if (this.vAreaOfInterestData.coordinate11 !== 0 && this.vAreaOfInterestData.coordinate12 !== 0
            && this.vAreaOfInterestData.coordinate31 !== 0 && this.vAreaOfInterestData.coordinate32 !== 0
        ) {
            return [[this.vAreaOfInterestData.coordinate11, this.vAreaOfInterestData.coordinate12], [this.vAreaOfInterestData.coordinate31, this.vAreaOfInterestData.coordinate32]]
        } else {
            return [];
        }
    }

    search(pSearchVal: string) {
        // added httpOptions as the search functionality was throwing CORS error.
        const httpOptions = {
            headers: new Headers({
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
            })
        };
        var promise = this._http.get(API_ENDPOINTS.ONEMAP.SEARCH + '?searchVal=' + pSearchVal + '&returnGeom=Y&getAddrDetails=Y&pageNum=1', httpOptions);
        let p = new Promise<void>((resolve, reject) => {
            promise.subscribe(
                (response) => {
                    let vResponseData: any = response;
                    console.log(vResponseData);
                    var i = 0;
                    for (let item of vResponseData.results) {
                        if (i > 4) {
                            break;
                        }
                        this.vSearchResults.push({
                            searchVal: item.SEARCHVAL,
                            latitude: item.LATITUDE,
                            longitude: item.LONGITUDE
                        });
                        i++;
                    }
                    resolve();
                },
                (error) => {
                    console.log();
                    reject();
                }
            );
        });
        return p;
    }

    loadA2AmountandAmountPay(pLocation) {
        this.vAreaOfInterestData.coordinate11 = pLocation[0].lat;
        this.vAreaOfInterestData.coordinate12 = pLocation[0].lng;
        this.vAreaOfInterestData.coordinate21 = pLocation[1].lat;
        this.vAreaOfInterestData.coordinate22 = pLocation[1].lng;
        this.vAreaOfInterestData.coordinate31 = pLocation[2].lat;
        this.vAreaOfInterestData.coordinate32 = pLocation[2].lng;
        this.vAreaOfInterestData.coordinate41 = pLocation[3].lat;
        this.vAreaOfInterestData.coordinate42 = pLocation[3].lng;

        var xData = {
            coordinate: [
                [pLocation[0].lat, pLocation[0].lng],
                [pLocation[1].lat, pLocation[1].lng],
                [pLocation[2].lat, pLocation[2].lng],
                [pLocation[3].lat, pLocation[3].lng]
            ]
        }
        this.vLoadingStatus = true;
        var promise = this._http.post(API_ENDPOINTS.PLANT_MAP.VERIFY_MAP, xData);
        let p = new Promise((resolve, reject) => {
            promise.subscribe(
                (response) => {
                    this.vLoadingStatus = false;
                    let vResponseData: any = response;
                    console.log(vResponseData);
                    this.vPaymentData.quantity = vResponseData.data.a2_paper;
                    this.vPaymentData.totalPrice = vResponseData.data.amount_payable;
                    this.vPaymentData.unitPrice = vResponseData.data.unit_price;
                    this._storageService.setSessionItem('plantMapPayment', JSON.stringify(this.vPaymentData));
                    this.vAreaOfInterestData.a2_amount = vResponseData.data.a2_paper;
                    this.vAreaOfInterestData.amount_payable = vResponseData.data.amount_payable;
                    resolve(vResponseData);
                },
                (error) => {
                    this.vLoadingStatus = false;
                    console.log(error);
                    let vErrorData = error;
                    this._errorService.setErrorFlag(true);
                    this._errorService.setBackEndError(vErrorData.code, vErrorData.desc);
                    reject();
                }
            );
        });
        return p;
    }

    //Kowsalya
    loadInvoive() {
        this.vLoadingStatus = true;
        let data = this._storageService.getSessionItem('plantMapData');
        this.vPlantMapData = JSON.parse(data);
        let xData = {
            plantRequestId: 'Test',
            email: 'Test',
            contractorCompanyName: 'Test Company',
            billNo: '12345',
            paymentDate: new Date(),
            location: 'Test Location',
            paymentType: 'Credit Card',
            subTotalAmount: '40',
            totalGST: '2.80',
            totalAmount: '42.80'

        }
        var promise = this._http.post(API_ENDPOINTS.PLANT_MAP.PLANTMAP_INVOICE, xData);

        let p = new Promise((resolve, reject) => {
            promise.subscribe(
                (response) => {
                    this.vLoadingStatus = false;
                    let vResponseData: any = response;
                    console.log(vResponseData);
                    resolve(vResponseData);
                },
                (error) => {
                    console.log(error);
                    this.vLoadingStatus = false;
                    let vErrorData = error;
                    this._errorService.setErrorFlag(true);
                    this._errorService.setBackEndError(vErrorData.code, vErrorData.desc);
                    reject();
                });
        });
        return p;
    }
    //Kowsalya

    LoadCompany() {
        this.vLoadingStatus = true;
        this._http.get(API_ENDPOINTS.PLANT_MAP.USER_DETAIL).subscribe(
            (response) => {
                this.vLoadingStatus = false;
                let vResponseData: any = response;
                console.log(vResponseData.data);
                let regType: any = vResponseData.data.registration_type;
                if (regType == 'C') {
                    console.log(vResponseData.data.registration_type);
                    this.vEarthworkDetailsData.purchaser_company_name = vResponseData.data.company_name;
                } else if (regType == 'F') {
                    console.log(vResponseData.data.registration_type);
                    this.vEarthworkDetailsData.purchaser_company_name = vResponseData.data.licence_id;
                }
            },

            (error) => {
                this.vLoadingStatus = false;
                console.log(error);
                let vErrorData = error;
                this._errorService.setErrorFlag(true);
                this._errorService.setBackEndError(vErrorData.code, vErrorData.desc);
            }
        );
    }

    callPrintpurchasePlanMap() {
        let payload = {
            "externalId": this.vPlantMapData.plant_record_id,
            'ori': this.vPlantMapData.plant_request_id,
            'restricted': this.vAreaOfInterestData.restricted_area,
            'mapCoordinates': [
                {
                    "x": this.vAreaOfInterestData.coordinate11,
                    "y": this.vAreaOfInterestData.coordinate12
                },
                {
                    "x": this.vAreaOfInterestData.coordinate21,
                    "y": this.vAreaOfInterestData.coordinate22
                },
                {
                    "x": this.vAreaOfInterestData.coordinate31,
                    "y": this.vAreaOfInterestData.coordinate32
                },
                {
                    "x": this.vAreaOfInterestData.coordinate41,
                    "y": this.vAreaOfInterestData.coordinate42
                }
            ]
        }

        this.userPasswordDetails()
            .then(
                (resolve) => {

                    Object.assign(payload, { 'documentPassword': this.password });

                    this.loadPlantmap(0, 10, 'requestId', '', '', 0, '').then(
                        (resolve) => {
                            let createDate = this.vPlantLists.find(x => x.plant_request_id === payload.ori).create_date;
                            let date = createDate.split(' ');
                            var formattedDate1 = [date[0].substring(3, 5), date[0].substring(0, 2), date[0].substring(6, 10)].join("/");

                            if (date[1].slice(-2) == 'PM') {
                                let v = date[1].slice(0, -2).split(':');
                                let hours = Number(v[0]) + 12;
                                let a = new Date(formattedDate1.concat(" ", hours.toString(), ":", v[1]));
                                var dateTime = moment(a).format('DD/MMM/YYYY hh:mm:ss A');
                                var purchaseDate = moment(a).format('YYYY-MM-DDTHH:mm:ss.SSS');
                            }
                            else {
                                let v = date[1].slice(0, -2).split(':');
                                let a = new Date(formattedDate1.concat(" ", v[0], ":", v[1]));
                                var dateTime = moment(a).format('DD/MMM/YYYY hh:mm:ss A');
                                var purchaseDate = moment(a).format('YYYY-MM-DDTHH:mm:ss.SSS');
                            }

                            let expiredDate = moment(dateTime).add(6, 'months')
                            let expiredFormattedDate = expiredDate.format('YYYY-MM-DDTHH:mm:ss.SSS'); // moment(expiredDate).format('DD/MMM/YYYY')
                            Object.assign(payload, { 'purchaseDate': purchaseDate }, { 'expiryDate': expiredFormattedDate });
                            console.log('SUNVIZION143 COORDINATES: ' + payload);
                            this._http.post(API_ENDPOINTS.PLANT_MAP.SUNVIZON143, payload).subscribe
                                (
                                    (response) => {
                                        // TO DO
                                    },
                                    (error) => {
                                        this.vLoadingStatus = false;
                                        let vErrorData = error;
                                        this._errorService.setErrorFlag(true);
                                        this._errorService.setBackEndError(vErrorData.code, vErrorData.desc);
                                    }
                                );
                            ;
                        },
                        (reject) => {
                            //this.vLoadingPlant = false;
                        }
                    );
                },
                (reject) => {
                    ;
                }
            )
    }

    userPasswordDetails() {
        var promise = this._http.get(API_ENDPOINTS.ACCOUNT.USER_PROFILE);
        let p = new Promise((resolve, reject) => {
            promise.subscribe(
                (response) => {
                    let vResponseData: any = response;
                    let fname = vResponseData.data.user.first_name;
                    let fourletters = vResponseData.data.user.licence_id ? vResponseData.data.user.licence_id : vResponseData.data.user.company_reg_no;
                    this.password = fname.substring(0, 4).toLowerCase() + fourletters.substring(fourletters.length - 4).toLowerCase();
                    resolve(this.password);
                },

                (error) => {
                    this.vLoadingStatus = false;
                    console.log(error);
                    let vErrorData = error;
                    this._errorService.setErrorFlag(true);
                    this._errorService.setBackEndError(vErrorData.code, vErrorData.desc);
                    reject();
                }
            );

        }



        )

        return p;

    }

    loadPlantmap(pPageNumber, pPageSize, pSearchBy, pFilterBy, pPlantStatus, pSortorder, pSortfield) {
        var promise = this._http.get(API_ENDPOINTS.PLANT_MAP.GET_USER_PLANTMAP + '?page_number=' + pPageNumber +
            '&page_size=' + pPageSize + '&search_by=' + pSearchBy + '&filter_by=' + pFilterBy + '&status=' + pPlantStatus +
            '&sortorder=' + pSortorder + '&sortfield=' + pSortfield);

        let p = new Promise<void>((resolve, reject) => {
            promise.subscribe(
                (response) => {
                    let vResponseData: any = response;
                    console.log(vResponseData, 'plantmaps api');
                    this.vPlantLists = vResponseData.data.plantmaps;

                    this.vPlantLists.forEach((element, index) => {
                        let tempTransAmount = '';
                        tempTransAmount = 'SGD ' + parseFloat(element.trans_amount).toFixed(2);
                        element.trans_amount = tempTransAmount;
                    });

                    resolve();
                },
                (error) => {
                    console.log(error);
                    let vErrorData = error;
                    this._errorService.setErrorFlag(true);
                    this._errorService.setBackEndError(vErrorData.code, vErrorData.desc);
                    reject();
                });
        });
        return p;
    }

}


// WEBPACK FOOTER //
// /home/maheshreddy/PRP_FE/src/app/plantmap/services/plant-map.service.ts